import { uuidGenerator, setInLocalStorage, getFromLocalStorage } from '@/helpers/utils';
import { isValidMiladyDate } from '@/helpers/utils';

const keyPrefix = 'global-';
const subPrefix = 'sub-';

export const calculateAge = (birthday) => {
    if (!isValidMiladyDate(birthday)) return 0;
    const diff = (new Date() - new Date(birthday)) / (1000 * 60 * 60 * 24 * 354.367056);
    return diff < 0 ? 0 : diff;
};

export const setValueInLocalStorage = (key, value) =>
    setInLocalStorage(`${keyPrefix}${key}`, value);

export const setSubValueInLocalStorage = (relatedId, key, value) => {
    const object = getValueFromLocalStorage(key, true);
    object[relatedId] = value;
    setInLocalStorage(`${subPrefix}${keyPrefix}${key}`, object);
};

export const updateSubValueInLocalStorage = (id, storageKey, value) => {
    const object = getValueFromLocalStorage(storageKey, true);
    for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            const index = object[key].findIndex(x => x.id === id);
            object[key][index] = {
                ...object[key][index],
                ...value,
            };
        }
    }
    setInLocalStorage(`${subPrefix}${keyPrefix}${storageKey}`, object);
};

export const getValueFromLocalStorage = (key, isSubObject) =>
    getFromLocalStorage(`${isSubObject ? subPrefix : ''}${keyPrefix}${key}`, isSubObject ? {} : []);

export const generateBasicFieldObject = () => {
    const fieldObject = {
        id: uuidGenerator(),
        typeId: null,
        name: null,
        label: null,
        columnSize: null,
        sortIndex: null,
        description: null,
        properties: {},
    };
    return fieldObject;
};

export const prepareDynamicFormObjectForAPI = (form) => {
    if (!form.fields || !form.fields.length) return form;
    return {
        ...form,
        fields: prepareDynamicFormFieldsForAPI(form.fields),
    };
};
export const prepareDynamicFormFieldsForAPI = fields =>
    fields.map((field) => {
        const { id, ...fieldWithoutId } = field;
        const gridConfig = field.properties && field.properties.dataGridConfig;
        return {
            ...fieldWithoutId,
            properties: JSON.stringify({
                ...field.properties,
                dataGridConfig: gridConfig
                    ? {
                        ...gridConfig,
                        fields: prepareDynamicFormFieldsForAPI(gridConfig.fields),
                    }
                    : null,
            }),
            fields: field.fields ? prepareDynamicFormFieldsForAPI(field.fields) : [],
        };
    });

export const parseFormFieldsProperties = (fields) => {
    return (fields || []).map((field) => {
        const properties = field.properties
            ? typeof field.properties === 'string'
                ? JSON.parse(field.properties)
                : field.properties
            : {};
        return {
            ...field,
            properties,
            fields: field.fields ? parseFormFieldsProperties(field.fields) : [],
        };
    });
};
